import { appsConf } from "./appDataConf.js";
import { chunksConf } from "./chunkDataConf.js";
import { dbName, dbVersion } from "./consts.js";
import { chunksMergeConf } from "./storeManagerConf/chunkCacheStoreManagerConf.js";



export class StoreBackend { }


export class IndexedDBManager extends StoreBackend {
  constructor(
    dbName,
    storeNameList,
  ) {
    super();

    if (
      !IndexedDBManager.dbNameToInstanceMap
    ) {
      IndexedDBManager.dbNameToInstanceMap = new Map;
    }

    if (
      IndexedDBManager.dbNameToInstanceMap.has(dbName)
    ) return IndexedDBManager.dbNameToInstanceMap.get(dbName);

    this.db = null;
    // this.queue = [];
    // this.isProcessing = false;

    this.dbName = dbName;
    this.storeNameList = storeNameList;

    IndexedDBManager.dbNameToInstanceMap.set(dbName, this);
  }

  async checkAndCreateStore(storeName) {
    const databases = await indexedDB.databases();
    const dbInfo = databases.find(db => db.name === this.dbName);

    let storeExists = false;

    let self = this;

    if (
      dbInfo
    ) {
      storeExists = await new Promise((resolve, reject) => {
        const request = indexedDB.open(self.dbName);

        request.onsuccess = function (event) {
          const db = event.target.result;
          const exists = db.objectStoreNames.contains(storeName);
          db.close();
          resolve(exists);
        };

        request.onerror = function (event) {
          reject(event.target.error);
        };
      });

      //TODO try catch for promise reject
    }

    if (
      !storeExists
    ) {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(self.dbName, dbInfo ? dbInfo.version + 1 : 1);

        request.onupgradeneeded = function (event) {
          const db = event.target.result;
          if (
            !db.objectStoreNames.contains(storeName)
          ) {
            db.createObjectStore(storeName);
          }
        };

        request.onsuccess = function (event) {
          const db = event.target.result;
          db.close();
          resolve();
        };

        request.onerror = reject;
      });


      //TODO try catch for reject
    }

    //TODO maybe not return anything it will be ok for promise resolve
    return true;
  }

  async openDB() {
    if (this.db) return this.db;

    let resolver, rejecter;

    let dbPrms = new Promise((resolve, reject) => {
      resolver = resolve;
      rejecter = reject;
    });

    for (let storeName of this.storeNameList) {
      await this.checkAndCreateStore(storeName);
    }

    let self = this;

    const request = indexedDB.open(this.dbName);

    request.onsuccess = (event) => {
      self.db = event.target.result;
      resolver(this.db);
    };

    request.onerror = rejecter;

    return dbPrms;
  }

  async executeOperation(storeName, operation) {

    // TODO this get executed more than 1 time
    let db = await this.openDB();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction(storeName, 'readwrite'); //TODO not all operations readwrite
      const store = transaction.objectStore(storeName);

      transaction.oncomplete = () => resolve();
      transaction.onerror = (event) => reject(`Transaction failed: ${event.target.error}`);

      try {
        operation(store);
      } catch (error) {
        reject(`Operation failed: ${error.message}`);
      }
    });
  }

  // async enqueueOperation(storeName, operation) {
  //   this.queue.push({ storeName, operation });

  //   if (!this.isProcessing) {
  //     this.isProcessing = true;
  //     while (this.queue.length > 0) {
  //       const { storeName, operation } = this.queue.shift();
  //       try {
  //         await this.executeOperation(storeName, operation);
  //       } catch (error) {
  //         console.error('Operation failed:', error);
  //       }
  //     }
  //     this.isProcessing = false;
  //   }
  // }
}


export const indexedDBStoreBackendSingleton = new IndexedDBManager(
  dbName,
  [
    appsConf.store,
    chunksConf.store,
    chunksMergeConf.store,
  ],
);
